import { generatePath } from "react-router-dom";

import { Insight } from "@/types/Insight";

import fetcher_v2 from "../fetcher_v2";
import { URLS } from "../urls";

export const getInsights = (uuid: Uuid, insight_ids?: number[]) => {
  return fetcher_v2<Insight[]>(generatePath(URLS.SEARCHES_INSIGHTS, { uuid }), {
    method: "GET",
    body: { ids: insight_ids },
  });
};
